const STORAGE_KEY = 'sellyt-product-tour';

export type ProductTourStatus = 'pending' | 'active' | 'completed' | 'skipped';

export interface ProductTourState {
  status: ProductTourStatus;
  stepIndex: number;
}

const defaultState = (): ProductTourState => ({
  status: 'pending',
  stepIndex: 0,
});

export const getProductTourState = (): ProductTourState => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return defaultState();
    const parsed = JSON.parse(raw) as ProductTourState;
    if (
      typeof parsed.stepIndex !== 'number' ||
      !['pending', 'active', 'completed', 'skipped'].includes(parsed.status)
    ) {
      return defaultState();
    }
    return parsed;
  } catch {
    return defaultState();
  }
};

export const setProductTourState = (state: ProductTourState) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
};

export const markProductTourPending = () => {
  setProductTourState({ status: 'pending', stepIndex: 0 });
};

export const activateProductTour = () => {
  setProductTourState({ status: 'active', stepIndex: 0 });
};

export const advanceProductTourStep = (nextIndex: number) => {
  setProductTourState({ status: 'active', stepIndex: nextIndex });
};

export const completeProductTour = () => {
  setProductTourState({ status: 'completed', stepIndex: 0 });
};

export const skipProductTour = () => {
  setProductTourState({ status: 'skipped', stepIndex: 0 });
};

export const restartProductTour = () => {
  setProductTourState({ status: 'pending', stepIndex: 0 });
};

export const isProductTourBlockingModals = () => {
  const { status } = getProductTourState();
  return status === 'pending' || status === 'active';
};

export const isProductTourActive = () => {
  const { status } = getProductTourState();
  return status === 'pending' || status === 'active';
};
